<script>
    import BaseListener from "@/assets/plugins/mps-common/event/base-listener";
    import {ON_MANUAL_RECEIVED} from "@/framework/listeners/listeners";

    /**
     * 매뉴얼 정보가 변경되었습니다.
     */
    export default {
        extends: BaseListener,
        name: "onManualReceived.vue",
        created() {
            this.registerListener(ON_MANUAL_RECEIVED, this.onManualReceived);
        },
        beforeDestroy() {
            this.unregisterListener(ON_MANUAL_RECEIVED, this.onManualReceived);
        }
    }
</script>
